import { Box, Paper, Typography } from "@mui/material";

import { PhoneAndEmailRenderer } from "~ui/atoms/DataGrid";
import { getDate, getTime } from "~utils/date";

export interface SchoolSignInCardProps {
  displayName: string;
  email?: string | null;
  phoneNumber?: string | null;
  /** ISO date-time string; when absent, the timestamp line is omitted. */
  timestamp?: string | null;
}

export function SchoolSignInCard({ displayName, email, phoneNumber, timestamp }: SchoolSignInCardProps) {
  return (
    <Paper variant="outlined" sx={{ p: 2 }}>
      <Typography fontWeight={600} variant="subtitle1">
        {displayName}
      </Typography>
      <Box sx={{ mt: 1 }}>
        <PhoneAndEmailRenderer email={email} phoneNumber={phoneNumber} />
      </Box>
      {timestamp ? (
        <Typography color="text.secondary" sx={{ mt: 1.5 }} variant="caption">
          {getDate(timestamp, "MMM d, yyyy")} · {getTime(timestamp)}
        </Typography>
      ) : null}
    </Paper>
  );
}
